// Import all required scripts

import './menu'